const TOO_MANY_REQUESTS_MESSAGE =
    'Muitas solicitações em pouco tempo. Aguarde alguns instantes e tente novamente.';

export class TooManyRequestsError extends Error {
    constructor() {
        super(TOO_MANY_REQUESTS_MESSAGE);
        this.name = 'TooManyRequestsError';
    }
}
